<template>
  <div class="custom-alert-container">
    <alert-alert />
  </div>
</template>

<script>
export default {
  name: 'CustomAlert',
  components: {},
}
</script>

<style lang="scss" scoped>
.custom-alert-container {
}
::v-deep .aa-container {
  @media screen and (max-width: 768px) {
    right: 0px !important;
    left: 0px;
  }
}
</style>
